import React from 'react';
import { createSlug } from '../../util/urlHelpers';
import { FormattedMessage } from '../../util/reactIntl';
import { IconProfileCard, NamedLink, ResponsiveImage } from '..';

import {
  PRODUCT_CLICKED_EVENT,
  algoliaEventTrackFn,
  clickedObjectIDsMethodName
} from '../../containers/AlgoliaSearchPage/AlgoliaEvents';

import { LISTING_CARD_2X } from '../../util/types';

import css from './AlogoliaSearchCard.module.css';
import { convertCardImageURLwebp } from '../../util/data';



const AlogoliaSearchCard = props => {
  const { hit, currentUser, algoliaState, currentPage } = props;
  const { title = "T", objectID, price, __queryID, __position, image_url, publicData, state } = hit || {};
  const { categoryName, subCategoryName, condition } = publicData || {};

  const variants = [LISTING_CARD_2X];
  const image = image_url ? {
    type: "image",
    attributes: {
      variants: {
        "listing-card-2x": {
          width: 800,
          height: 533,
          url: convertCardImageURLwebp(image_url)
        },
        "scaled-medium": {
          width: 750,
          height: 750,
          url: convertCardImageURLwebp(image_url)
        }
      }
    }
  } : image_url;

  const namedLinkTo = currentUser?.id?.uuid ? {
    to: {
      search: `?aQueryId=${__queryID}`
    }
  } : {};

  return (
    <div className={css.root} key={objectID} onClick={(e) => {
      try {
        e.preventDefault();
        if (currentUser?.id?.uuid) {
          const userID = currentUser.id.uuid;
          algoliaEventTrackFn(clickedObjectIDsMethodName, {
            index: process.env.REACT_APP_ALGOLIA_LISTING_INDEX,
            eventName: PRODUCT_CLICKED_EVENT,
            queryID: __queryID,
            userToken: userID,
            objectIDs: [objectID],
            positions: [__position],
            eventData: {
              listingID: objectID,
              queryID: __queryID,
              userID,
              timestamp: new Date().toISOString(),
            }
          });
        };
      } catch (e) {
        console.log(e, '&&& &&& => e');
      }
    }} >
      <NamedLink
        name="ListingPage"
        params={{
          id: objectID,
          slug: createSlug(title),
          category: createSlug(categoryName || "category"),
          subCategory: createSlug(subCategoryName || "sub-category")
        }}
        className={css.link}
        isSearchPage={true}
        {...namedLinkTo}
      >
        <div className={css.container}>
          <div className={css.imageBox}>
            {
              image_url ?
                <ResponsiveImage
                  alt={"We're having trouble loading product images. Please try again later."}
                  image={image}
                  variants={variants}
                />
                :
                <div className={css.noImageIcon}><IconProfileCard type="no_image" /><FormattedMessage id="ResponsiveImage.noImage" /></div>
            }
          </div>
          <div className={css.imageDetails}>
            <p className={state == "closed" ? css.storeClosedName : css.storeName}>{state == "closed" ? <FormattedMessage id="ManageListingCard.thislistingIOsClosed" /> : `${categoryName} | ${subCategoryName}`}</p>
            <p className={css.title}>{title}</p>
            <p className={css.price}>{price ? `$${price.toFixed(2)}` : null}<b>USD</b></p>
          </div>
          {condition ? <div className={css.condition}>{condition}</div> : null}
        </div>
      </NamedLink>
    </div>
  );
};

export default AlogoliaSearchCard;
